const initial = {
  isOpen: false,
  isLoading: false,
  error: false,
  next: null,
  phone: ""
};

const toggleModal = (state, { payload: { isOpen, next } }) => ({
  ...state,
  isOpen,
  next
});

const setError = (state, { payload }) => ({ ...state, error: payload });

const setLoading = (state, { payload }) => ({ ...state, isLoading: payload });

const setPhone = (state, { payload }) => ({ ...state, phone: payload });

const REDUCERS = {
  IP_TELMEX_UPDATE_EMAIL_OPEN_MODAL: toggleModal,
  IP_TELMEX_UPDATE_EMAIL_CLOSE_MODAL: toggleModal,
  IP_TELMEX_SET_ERROR: setError,
  IP_TELMEX_SET_LOADING: setLoading,
  IP_TELMEX_SET_PHONE: setPhone
};

export default (state = initial, action) =>
  action.type in REDUCERS ? REDUCERS[action.type](state, action) : state;
